import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history/History_of_Sci_&_Tech_-_Space_Race.png';

function HistoryPageSpaceRaceGo() {
  return (
    <QuizPage
      title="History: Space Race"
      subTopic="Space Race"
      backgroundImage={historyImage}
      returnPath="/History-Space-Race"
    />
  );
}

export default HistoryPageSpaceRaceGo;
